import { Dialog as DialogPrimitive } from 'radix-ui';
import { X } from 'lucide-react';
import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/utils';

// shadcn/ui-style dialog on Radix, in the neon look.
export const Dialog = DialogPrimitive.Root;
export const DialogTitle = DialogPrimitive.Title;
export const DialogDescription = DialogPrimitive.Description;

export function DialogContent({
  className,
  children,
  title,
  ...props
}: ComponentProps<typeof DialogPrimitive.Content> & { title: ReactNode }) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/60" />
      <DialogPrimitive.Content
        className={cn(
          'fixed top-1/2 left-1/2 z-50 flex max-h-[85dvh] w-[min(560px,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 flex-col gap-4 overflow-y-auto border border-magenta bg-bg-2 p-5 shadow-[0_0_32px_rgb(255_43_214/0.2)] outline-none',
          className,
        )}
        {...props}
      >
        <div className="flex items-start gap-2">
          <DialogPrimitive.Title className="flex-1 font-display text-sm font-bold tracking-[0.14em] text-cyan uppercase">
            {title}
          </DialogPrimitive.Title>
          <DialogPrimitive.Close className="cursor-pointer p-1 text-muted hover:text-text" aria-label="Close">
            <X className="size-4" aria-hidden />
          </DialogPrimitive.Close>
        </div>
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
